import React from 'react';
import styles from './onboarding.module.css';

export default function Intro({ name }) {
    return (
        <>
            <div></div> {/* Empty div for centering */}
            <div className={styles.flexDiv} style={{ margin: "0 0.2rem", gap: '3rem' }}>
                <div>
                    <h1 className={styles.onboardingGreeting} style={{ marginBottom: "0.5rem" }}>
                        Find Balance.
                    </h1>
                    <h1 className={styles.onboardingGreeting} style={{ marginBottom: "0.75rem" }}>
                        Stay Ahead of Burnout.
                    </h1>
                    <p className={styles.onboardingSubgreeting}>
                        With data, not guesswork
                    </p>
                </div>
                <div className={styles.flexDiv} style={{ textAlign: "center" }}>
                    {/* <p className={styles.para}>
                        When your week's a blur {name}, <br />
                        Normili holds up <strong>the big picture</strong> of what fulfilled and drained you. So you can
                        <strong> pivot before burning out.</strong>
                    </p> */}
                    <p className={styles.para}>
                        Normili shows you how work's impacting your mental health, so you can <strong>shift</strong> towards balance, <strong>not drift</strong> towards burnout.
                    </p>
                </div>
            </div>
        </>
    );
}
